import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { ProjectLocationCustomNotes } from "./CustomNotes";
import { PickupFields } from "./PickupFields";
import useLocation from "../../../../containers/FacilityDetailsPage/hooks/useLocation";
import { ProjectsLocationsData } from "../../../../models/ProjectData";
import ScoreItem from "../../../ScoreItem";

import "./styles.scss";

export interface IProjectFacilityDetailsModalProps {
  organizationId: string;
  projectLocation: ProjectsLocationsData;
  handleClose: () => void;
}

export const ProjectFacilityDetailsModal: React.FC<
  IProjectFacilityDetailsModalProps
> = (props) => {
  const { organizationId, projectLocation, handleClose } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`projectManagementPage.projectFacilityDetailsModal.${key}`);

  const { data: locationData } = useLocation(projectLocation.location_id);

  return (
    <div className="modal modal-default modal-project-facility-details">
      <div className="modal-mains">
        <button className="btn-close" onClick={handleClose}></button>
        <div className="modal-mains__body">
          <div>
            <div className="top-title">
              <span>{projectLocation.location.name}</span>
              <ScoreItem
                score={projectLocation.location.location_stats?.score || "n"}
              />
            </div>
            <div className="registered">
              <span>{t("registered")}</span>
              <span>
                {dayjs(projectLocation.project_join_date).format("YYYY/MM/DD")}
              </span>
            </div>
          </div>
          <div className="basic-info">
            {locationData && (
              <PickupFields locationData={locationData}></PickupFields>
            )}
          </div>
          <div className="custom-notes">
            <ProjectLocationCustomNotes
              organizationId={organizationId}
              projectLocation={projectLocation}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
